import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function CarouselPage() {
  return (
    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <video className="d-block w-100" autoPlay loop muted playsInline>
            <source src={require("./images/site_exit_website_banner_video_montage__(1)_(2) (1080p).mp4")} type="video/mp4" />
          </video>
        </div>
        {/* <div className="carousel-item">
          <img className="d-block w-100" src="https://via.placeholder.com/800x400" alt="Second slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src="https://via.placeholder.com/800x400" alt="Third slide" />
        </div> */}
      </div>
      {/* <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button> */}
    </div>
  );
}

export default CarouselPage;
